import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-open-account',
  templateUrl: './open-account.component.html',
  styleUrls: ['./open-account.component.scss']
})
export class OpenAccountComponent implements OnInit {

  constructor( private router:Router) { }

  ngOnInit(): void {
    this.router.navigate(["customer-search"]);
  }
 
  
}
